import { AxiosError } from "axios";
import { ILoginUserData, ICurrentHover, ILockedModal } from "../Models/Models";
import {
    GetLoginUserDataAction,
    GetLoginUserDataFailureAction,
    GetLoginUserDataSuccessAction,
    GET_LOGIN_USER_DATA,
    GET_LOGIN_USER_DATA_FAILURE,
    GET_LOGIN_USER_DATA_SUCCESS,
    SetFetchingLoginUserDataAction,
    SET_FETCHING_LOGIN_USER_DATA,
    SetCurrentHoverAction,
    SetLockedModalAction,
    SET_CURRENT_HOVER,
    SET_LOCKED_MODAL,
} from "../Types/LoginActionTypes";

/** misc */
export const setFetchingLoginUserData = (loading: boolean): SetFetchingLoginUserDataAction => ({
    type: SET_FETCHING_LOGIN_USER_DATA,
    data: loading,
});

export const getLoginUserData = (): GetLoginUserDataAction => ({
    type: GET_LOGIN_USER_DATA,
    data: null,
});

/** success */
export const getLoginUserDataSuccess = (userData: ILoginUserData): GetLoginUserDataSuccessAction => ({
    type: GET_LOGIN_USER_DATA_SUCCESS,
    data: userData,
});

/** failure */
export const getLoginUserDataFailure = (error: AxiosError): GetLoginUserDataFailureAction => ({
    type: GET_LOGIN_USER_DATA_FAILURE,
    data: error.message,
});

/* hover */
export const setCurrentHover = (currentHover: ICurrentHover): SetCurrentHoverAction => ({
    type: SET_CURRENT_HOVER,
    data: currentHover,
});

export const setLockedModal = (lockedModal: ILockedModal): SetLockedModalAction => ({
    type: SET_LOCKED_MODAL,
    data: lockedModal,
});
